// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"label_1aNfm","isThemeLight":"label_1pXY3","isThemeDark":"label_Adwd5","description":"label_359d4"};